/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRefCallback } from "@enfusion-ui/hooks";
import * as React from "react";
import { getContextMenuPlacement } from "../contextPlacement";
export function useContextMenu() {
    const [contextMenuOpen, setContextMenuOpen] = React.useState(false);
    const [contextMenuNode, setContextMenuNode] = React.useState(null);
    const handleContextMenuPlacement = useRefCallback((windowWidth, windowHeight, portalElementRef) => {
        return getContextMenuPlacement(windowWidth, windowHeight, portalElementRef, contextMenuNode);
    }, [contextMenuNode]);
    const handleContextEvent = useRefCallback((e) => {
        e.preventDefault();
        // Right click event identified by e.button === 2
        if (e.button === 2) {
            setContextMenuNode({
                clientY: e.nativeEvent.clientY,
                clientX: e.nativeEvent.clientX,
            });
            setContextMenuOpen(true);
        }
        else {
            e.stopPropagation();
        }
    }, []);
    const closeContextMenu = useRefCallback(() => setContextMenuOpen(false), []);
    const openContextMenu = useRefCallback(() => setContextMenuOpen(true), []);
    return React.useMemo(() => ({
        contextMenuOpen,
        contextMenuNode,
        openContextMenu,
        closeContextMenu,
        handleContextEvent,
        setContextMenuNode,
        handleContextMenuPlacement,
    }), [
        contextMenuOpen,
        contextMenuNode,
        openContextMenu,
        closeContextMenu,
        handleContextEvent,
        setContextMenuNode,
        handleContextMenuPlacement,
    ]);
}
